import { handleActions } from 'redux-actions';
import { assoc, mergeLeft } from 'ramda';

import {
  requestPatientsResourceById,
  requestPatientsResourceByIdFailure,
  requestPatientsResourceByIdSuccess,
} from 'store/actionCreators/patient';

const defaultState = {
  loading: false,
  editPatient: null,
};

export default handleActions(
  {
    [requestPatientsResourceById]: state => assoc('loading', true, state),
    [requestPatientsResourceByIdSuccess]: (state, { payload: { response } }) =>
      mergeLeft({ editPatient: response, loading: false }, state),
    [requestPatientsResourceByIdFailure]: state => assoc('loading', false, state),
  },
  defaultState,
);
